export enum EndpointsCheckoutQueryKeys {
  Checkout = '/checkout',
  TokenizeCheckout = '/tokenization/types',
}

export enum CheckoutQueryKeys {
  Checkout = 'checkout',
  TokenizeCheckout = 'tokenize-checkout',
}
